import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import Vue from 'vue';

var requireContext = require.context('../directives/src/', false, /^\.\/.*\.js$/);

var files = requireContext.keys() || [];
files.forEach(function (key) {
  var moduleName = key.replace(/^.*\/|\..*$/g, '');
  var directive = requireContext(key);
  directive = directive.__esModule && directive.default ? directive.default : directive;
  Vue.directive(moduleName, directive);
});